import { Injectable } from '@angular/core';

import * as $ from 'jquery';
import { MapServiceService } from '../Map-service/map-service.service';

@Injectable({
  providedIn: 'root',
})
export class ForwardBackwardToolServiceService {
  map: any;
  stack: any;
  index: any;
  last: any;
  moving: any;
  constructor(private mapService: MapServiceService) {}

  public history(map: any) {
    this.map = map;
    this.stack = [];
    this.index = -1;
    this.last = new Date(1986, 12, 14);
    this.pushData();

    // const self = this;

    // this.map.events.on({
    //   moveend: function () {
    //     if (!self.moving) self.push();
    //     self.moving = false;
    //   },
    // });
  }

  atBeginning = () => {
    return this.index < 1;
  };

  atEnd = () => {
    return this.index >= this.stack.length - 1;
  };

  back = () => {
    if (this.index > 0) {
      this.index -= 1;
      this.go();

      this.trigger();
    }
  };

  forward = () => {
    if (this.index + 1 < this.stack.length) {
      this.index += 1;
      this.go();

      this.trigger();
    }
  };

  go = () => {
    this.moving = true;
    const c = this.stack[this.index];
    //for open layer 6 working fine
    this.map.getView().setCenter(c.center);
    this.map.getView().setZoom(c.zoom);
  };

  public pushData = () => {
    while (this.stack.length > this.index + 1) {
      this.stack.pop();
    }

    const time = new Date();
    const data = {
      center: this.map.getView().getCenter(),
      zoom: this.map.getView().getZoom(),
    };

    if (time.getTime() - this.last.getTime() < 1000) {
      this.stack[this.index] = data;
    } else {
      this.stack.push(data);
      this.index += 1;
    }

    this.last = time;
    this.trigger();
  };

  trigger = () => {
    $(document).trigger('historychanged', [this]);
  };
}
